import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'customize-button',
  templateUrl: './customize-button.component.html',
  styleUrls: ['./customize-button.component.scss'],
  host: {
    '[style.width]': 'width',
    '[style.min-width]': 'minWidth',
    '[style.max-width]': 'maxWidth',
    '[class.keep-color]': 'awayTheme',
  },
})
export class CustomizeButtonComponent implements OnInit {
  constructor() {}

  /**图标 */
  @Input() icon!: string;
  /**宽度 */
  @Input() width!: string;
  /**最小宽度 */
  @Input() minWidth!: string;
  /**最大宽度 */
  @Input() maxWidth!: string;
  /**类型
   * primary 主要
   * normal 一般按钮
   * default 按钮（默认值）
   * plain-primary btn/按钮/线框默认2
   * plain-default btn/按钮/线框默认
   * select btn/按钮/小选择按钮
   */
  @Input() type:
    | 'primary'
    | 'secondary'
    | 'primary-linear'
    | 'secondary-linear'
    | 'normal'
    | 'text-normal'
    | 'plain-primary'
    | 'plain-default'
    | 'select'
    | 'default'
    | 'text'
    | 'plain-text' = 'default';
  /**大小 */
  @Input() size: 'larger' | 'large' | 'large-medium' | 'medium' | 'medium-small' | 'small' | 'mini' = 'medium';
  /**圆角 */
  @Input() radius: string = '0.8rem';
  /**边框型按钮。会在类型的基础上淡化背景色，无边框的会加上边框*/
  @Input() plain!: boolean;
  /**是否加载中 */
  @Input() loading!: boolean;
  /**是否激活（相当于hover） */
  @Input() active!: boolean;
  /**是否禁用 */
  @Input() disabled!: boolean;
  /**脱离主题 */
  @Input() awayTheme: boolean = false;

  /**点击事件 */
  @Output() onClick: EventEmitter<MouseEvent> = new EventEmitter();
  @Output() onReady: EventEmitter<MouseEvent> = new EventEmitter();

  @ViewChild('button') button!: ElementRef<HTMLInputElement>;

  click(e: MouseEvent) {
    if (this.loading || this.disabled) return;
    this.onClick.emit(e);
  }

  ngOnInit(): void {
    this.onReady.emit();
  }
}
